module.exports = __webpack_public_path__ + "img/magnifyBusinessLicense.be502f3a.png";